module.exports = __webpack_public_path__ + "static/assets/e50acbfb2bf918125266f2de0903566c.png";